/**
 * Переключатели разделов.
 *
 * Скрываем флагом, а не удалением: код, данные и роуты остаются на месте,
 * вернуть раздел — одна строка здесь.
 */

/**
 * Тренировки. Скрыты 29.08.2026 перед запуском, решение Славы.
 *
 * Причина — цифры, а не вкусовщина: 27 планов создали 9 человек, но реально
 * начали тренировку ТРОЕ и всего 4 раза, а последняя тренировка была 19 июля.
 * План создать легко, провести тренировку — работа, и на ней всё обрывалось.
 * Плюс каждая шестая гифка (212 из 1324) битая — осталась на чужом мёртвом CDN.
 *
 * Открыть обратно, когда будут нормальные гифки и анимации — Слава планирует
 * выкатить это отдельным обновлением, как приятную новость, а не как строчку,
 * которая была и молчала.
 */
export const SHOW_WORKOUTS = false;
